/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StoreProfilePaymentMethod
 */
export interface StoreProfilePaymentMethod {
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePaymentMethod
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePaymentMethod
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePaymentMethod
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof StoreProfilePaymentMethod
     */
    icon: string;
}

/**
 * Check if a given object implements the StoreProfilePaymentMethod interface.
 */
export function instanceOfStoreProfilePaymentMethod(value: object): value is StoreProfilePaymentMethod {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('icon' in value) || value['icon'] === undefined) return false;
    return true;
}

export function StoreProfilePaymentMethodFromJSON(json: any): StoreProfilePaymentMethod {
    return StoreProfilePaymentMethodFromJSONTyped(json, false);
}

export function StoreProfilePaymentMethodFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreProfilePaymentMethod {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'description': json['description'],
        'icon': json['icon'],
    };
}

export function StoreProfilePaymentMethodToJSON(json: any): StoreProfilePaymentMethod {
    return StoreProfilePaymentMethodToJSONTyped(json, false);
}

export function StoreProfilePaymentMethodToJSONTyped(value?: StoreProfilePaymentMethod | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'description': value['description'],
        'icon': value['icon'],
    };
}

